<template>
  <div>
    <section class="section">
      <div class="columns">
        <div class="column panel">
          <div class="column panel-heading">
            <div class="title is-4 has-text-info uppercase mb-4">
              Récapitulatif de votre liaison préconnectée
            </div>
            <TrunkVisual
              :extremite-a="trunk.configuration.extremite_a"
              :extremite-b="trunk.configuration.extremite_b"
              :mode="trunk.configuration.mode"
              :with-details="false"
              :type-de-gaine="trunk.configuration.type_de_gaine"
              :nombre-de-brins="trunk.configuration.nombre_de_brins"
              :longueur="trunk.configuration.longueur_du_lien"
            />
          </div>
          <div class="column mt-1 columns">
            <div class="column mr-4 is-one-third panel-heading">
              <div class="title is-4 has-text-info uppercase mb-4">
                Récapitulatif de vos options
              </div>
              <div class="is-flex flex-col">
                <b-field>
                  <b-checkbox
                    :value="!trunk.options.reflectometrie"
                    :disabled="true"
                  >
                    Photométrie
                  </b-checkbox>
                </b-field>
                <b-field>
                  <b-checkbox
                    :value="trunk.options.reflectometrie"
                    :disabled="true"
                  >
                    Réflectométrie
                  </b-checkbox>
                </b-field>
                <b-field>
                  <b-checkbox
                    :value="trunk.options.regainage"
                    :disabled="true"
                  >
                    Regainage
                  </b-checkbox>
                </b-field>
                <b-field>
                  <b-checkbox
                    :value="trunk.options.chaussette"
                    :disabled="true"
                  >
                    2ème chaussette de tirage
                  </b-checkbox>
                </b-field>
                <b-field>
                  <b-checkbox
                    :value="trunk.options.livraison"
                    :disabled="true"
                  >
                    Livraison express
                  </b-checkbox>
                </b-field>
              </div>
            </div>
            <div class="column panel-heading">
              <div class="title is-4 has-text-info uppercase mb-4">
                Récapitulatif de vos tiroirs optiques
              </div>
              <div class="columns">
                <div class="column flex flex-col items-center">
                  <div class="title is-5 has-text-primary uppercase">
                    Tiroir optique - A
                  </div>
                  <div v-if="trunk.configuration.tiroir_a_id">
                    <div class="is-size-6 mb-2">
                      {{
                        formatTiroirName(getTiroirById(trunk.configuration.tiroir_a_id).designation)
                      }}
                    </div>
                    <component
                      :is="require(`@/assets/unitrunk/tiroirs/${getTiroirById(trunk.configuration.tiroir_a_id).svg}`)"
                    />
                  </div>
                  <div v-else>
                    Je n'ai pas choisi de tiroir optique
                  </div>
                </div>
                <div class="column flex flex-col items-center">
                  <div class="title is-5 has-text-primary uppercase">
                    Tiroir optique - B
                  </div>
                  <div v-if="trunk.configuration.tiroir_b_id">
                    <div class="is-size-6 mb-2">
                      {{ formatTiroirName(getTiroirById(trunk.configuration.tiroir_b_id).designation) }}
                    </div>
                    <component
                      :is="require(`@/assets/unitrunk/tiroirs/${getTiroirById(trunk.configuration.tiroir_b_id).svg}`)"
                    />
                  </div>
                  <div
                    v-else
                  >
                    Je n'ai pas choisi de tiroir optique
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="trunk"
          class="column is-one-quarter panel"
        >
          <div class="panel-heading">
            <div class="title is-4 has-text-info uppercase mb-4">
              Votre Configuration
            </div>
            <p class="title is-4 has-text-primary uppercase">
              Trunk avec options
            </p>
            <p class="is-size-6 has-text-weight-bold uppercase has-text-primary">
              Référence
            </p>
            <p class="uppercase">
              {{ trunk.trunkSimulation.reference }}
            </p>
            <p class="is-size-6 has-text-weight-bold uppercase has-text-primary has-text-right">
              Votre prix
            </p>
            <p class="uppercase has-text-right">
              {{ trunk.trunkSimulation.trunk_price }} € HT
            </p>

            <div v-if="trunk.trunkSimulation.tiroirs_prices.tiroir_a.price">
              <hr class="has-background-primary">
              <p class="title is-5 has-text-primary uppercase">
                Tiroir optique - A
              </p>
              <p class="is-size-6 has-text-weight-bold uppercase is-size-6 has-text-primary">
                Référence
              </p>
              <p class="uppercase">
                {{ trunk.trunkSimulation.tiroirs_prices.tiroir_a.reference }}
              </p>
              <p class="is-size-6 has-text-weight-bold uppercase has-text-primary has-text-right">
                Votre prix
              </p>
              <p class="uppercase has-text-right">
                {{ trunk.trunkSimulation.tiroirs_prices.tiroir_a.price }} € HT
              </p>
            </div>

            <div v-if="trunk.trunkSimulation.tiroirs_prices.tiroir_b.price">
              <hr class="has-background-primary">
              <p class="title is-5 has-text-primary uppercase">
                Tiroir optique - B
              </p>
              <p class="is-size-6 has-text-weight-bold uppercase has-text-primary">
                Référence
              </p>
              <p class="uppercase">
                {{ trunk.trunkSimulation.tiroirs_prices.tiroir_b.reference }}
              </p>
              <p class="is-size-6 has-text-weight-bold uppercase has-text-primary has-text-right">
                Votre prix
              </p>
              <p class="uppercase has-text-right">
                {{ trunk.trunkSimulation.tiroirs_prices.tiroir_b.price }} € HT
              </p>
            </div>

            <div>
              <hr class="has-background-primary">
              <p class="title is-5 has-text-primary uppercase">
                <span v-if="trunk.trunkSimulation.livraison_express">
                  Livraison express
                </span>
                <span v-else>
                  Livraison standard
                </span>
              </p>
              <p class="is-size-6 has-text-weight-bold uppercase has-text-primary has-text-right">
                Votre prix
              </p>
              <p class="uppercase has-text-right">
                <span v-if="trunk.trunkSimulation.livraison_express">
                  52,00 € HT
                </span>
                <span v-else>
                  25,00 € HT
                </span>
              </p>
            </div>

            <hr class="has-background-primary">
            <div class="mt-3">
              <p class="is-size-3 has-text-weight-bold has-text-primary uppercase has-text-right">
                TOTAL
              </p>
              <p class="is-size-3 has-text-weight-bold uppercase has-text-right">
                {{ trunk.trunkSimulation.total_price }} € HT
              </p>
            </div>

            <div class="mt-3">
              <b-button
                class="is-info mb-2"
                icon-left="euro-sign"
                expanded
                :loading="trunk.quoteLoading"
                @click="isAddressModalActive = true"
              >
                Recevoir mon devis par mail
              </b-button>
              <b-button
                class="is-info mb-4"
                icon-left="file"
                expanded
                :loading="trunk.dossierLoading"
                @click="askSummary"
              >
                Recevoir mon dossier technique par email
              </b-button>

              <b-button
                v-if="trunk.trunkSimulation.commercial_prices"
                class="is-success mb-4"
                icon-left="file"
                expanded
                @click="isCommercialModalActive = true"
              >
                Afficher tous les prix
              </b-button>
              <hr class="has-background-primary">
              <b-button
                class="is-primary"
                expanded
                @click="newConfiguration"
              >
                Nouvelle configuration
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <BaseModal
      title="Compléments d'informations"
      :active="isAddressModalActive"
      @submit="closeModalAndAskQuote"
    >
      <template v-slot:body>
        <b-field label="Adresse de facturation* (champ obligatoire)">
          <b-input
            v-model="billing_address"
            type="textarea"
            required
          />
        </b-field>

        <b-field label="Numéro SIRET">
          <b-input
            v-model="siret"
            type="text"
          />
        </b-field>
      </template>

      <template v-slot:footer>
        <button
          class="button"
          type="button"
          @click="isAddressModalActive = false"
        >
          Annuler
        </button>
        <button class="button is-primary">
          Valider
        </button>
      </template>
    </BaseModal>
    <b-modal
      v-if="trunk.trunkSimulation.commercial_prices"
      :active="isCommercialModalActive"
      title="Tous les prix"
      aria-role="dialog"
      aria-modal
      has-modal-card
    >
      <div
        class="modal-card"
        style="width: auto"
      >
        <header
          class="modal-card-head"
        >
          Tous les prix
        </header>

        <section class="modal-card-body">
          <table>
            <tr>
              <th>Produit</th>
              <th
                v-for="category in pricingCategories"
                :key="category"
              >
                {{ category }}
              </th>
            </tr>
            <tr>
              <td>Trunk</td>
              <td
                v-for="category in pricingCategories"
                :key="category"
              >
                {{ trunk.trunkSimulation.commercial_prices.trunk_prices[category] }} €
              </td>
            </tr>
            <tr>
              <td>Tiroir A</td>
              <td
                v-for="category in pricingCategories"
                :key="category"
              >
                {{ trunk.trunkSimulation.commercial_prices.tiroirs_all_prices[category].tiroir_a.price || 0 }} €
              </td>
            </tr>
            <tr>
              <td>Tiroir B</td>
              <td
                v-for="category in pricingCategories"
                :key="category"
              >
                {{ trunk.trunkSimulation.commercial_prices.tiroirs_all_prices[category].tiroir_b.price || 0 }} €
              </td>
            </tr>
            <tr>
              <th>Total</th>
              <th
                v-for="category in pricingCategories"
                :key="category"
              >
                {{ trunk.trunkSimulation.commercial_prices.total_prices[category] }} €
              </th>
            </tr>
          </table>
        </section>
      </div>
      <footer class="modal-card-foot">
        <button
          class="button is-success"
          type="button"
          @click="isCommercialModalActive = false"
        >
          ok
        </button>
      </footer>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import TrunkVisual from '@/views/partials/TrunkVisual.vue';
import BaseModal from '@/components/BaseModal.vue';
import trunkMixin from '@/views/mixins/trunkMixin';

export default {
  name: 'Trunk',
  components: { TrunkVisual, BaseModal },
  mixins: [trunkMixin],
  data() {
    return {
      isCommercialModalActive: false,
      isAddressModalActive: false,
    };
  },
  computed: {
    ...mapState(['trunk']),
    ...mapGetters('trunk', ['getTiroirById']),
    ...mapFields('authentication', ['user.siret', 'user.billing_address']),
    pricingCategories() {
      return Object.keys(this.trunk.trunkSimulation.commercial_prices.trunk_prices);
    },
  },
  mounted() {
    Array.from(document.querySelectorAll('label')).forEach((el) => {
      el.classList.remove('is-disabled');
      el.removeAttribute('disabled');
    });
  },
  methods: {
    ...mapActions('trunk', ['askQuote', 'askSummary', 'newConfiguration']),
    closeModalAndAskQuote() {
      this.isAddressModalActive = false;
      this.askQuote();
    },
  },
};
</script>

<style lang="scss">
input[type=checkbox][disabled]{
  outline:1px solid red; // or whatever
}

table td {
    padding:0 20px !important;
}
</style>
